import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What the app launcher still reads from the workspace: its open flag, which the top bar button, Escape and outside-click handling also drive.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmShellAppLauncherHost = Pick<
  PmWorkspaceComponent,
  | 'isAppLauncherOpen'
  | 'reminders'
  | 'stopProp'
>;

export const PM_SHELL_APP_LAUNCHER_HOST = new InjectionToken<PmShellAppLauncherHost>('PmShellAppLauncherHost');
